const reprovarTemplate = require('../templates/reprovar.html');
const Lang = require('lang');
const ga4 = require('../ga4/ga4');

exports.init = function confirm() {
  $('button[data-id]').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $button = $(e.target);

    $button = $button[0].localName === 'button' ? $button : $button.closest('[data-id]');

    const title = $button.data('title') || $button.prop('title') || Lang.get('js/src/events/confirm.confirm_action');
    const type = $button.data('type');
    const locale = Lang.getLocale().slice(0, 2) === 'pt' ? 'br' : Lang.getLocale().slice(0, 2);
    let message = $button.data('message') || Lang.get('js/src/events/confirm.are_you_sure_to_do_it');
    const size = $button.data('size') || 'medium';
    const form = 'form[data-id=' + $button.data('id') + ']';
    const $form = $button.closest(form);
    const confirmLabel = $button.data('confirmLabel');
    const massAssignment = $button.data('massAssignment');
    // Botão de deletar padrão ou o botão dinamico da pagina de despesa
    const dataGA4 = $(this).data('ga4-id') || $(this).parent().parent().data('ga4-id');
    const confirmDeleteGA4 = ['expenses_deleteItemTable', 'expenses_deleteExpense'].includes(dataGA4);
    const confirmSendToApprovalGA4 = ['-reports_enviarAprovacao'].includes(dataGA4);
    let confirmed = false;

    nifty.document.on('input', '#justificativaModal', function (e) {
      $form.find('[name=justificativa]').val(e.target.value);
    });

    nifty.document.on('input', '#confirmMassAssignment', function (e) {
      const label = $('label[for="confirmMassAssignment"]');
      confirmed = !confirmed

      // Habilita / Desabilita o botão de confirmar do bootbox
      document.querySelector('.bootbox-accept').disabled = !confirmed;

      // Ativa / Desativa o checkbox da modal
      if (confirmed) {
        label.addClass('active');
      } else {
        label.removeClass('active');
      }
    });

    const submitForm = function (result) {
      result && $form.trigger('submit');
    };

    // Se tiver a flag de vinculo em massa adiciona o checkbox no modal
    if (massAssignment) {
      message += createConfirmationCheckbox()
    }

    const options = {
      size: size,
      title: title,
      message: type == 'reprovar' ? reprovarTemplate : message,
      buttons: {
        confirm: {
          className: type === 'delete' ? 'btn-danger' : 'btn-mint',
          label: confirmLabel
        },
        cancel: {
          label: Lang.get('js/common/words.cancel')
        }
      },
      callback: submitForm
    };

    bootbox.setLocale(locale);
    const modal = bootbox.confirm(options);

    if (confirmDeleteGA4) {
      modal.find('.bootbox-cancel').on('click', () => {
        ga4.event('-expenses_cancelDeleteExpenseItem')();
      })

      modal.find('.bootbox-accept').on('click', () => {
        ga4.event('-expenses_confirmDeleteExpenseItem')();
      })
    }

    if (confirmSendToApprovalGA4) {
      modal.find('.bootbox-cancel').on('click', () => {
        ga4.event('-reports_cancelSendToApproval')();
      })

      modal.find('.bootbox-accept').on('click', () => {
        ga4.event('-reports_sendToApproval')();
      })
    }

    // Se tiver a flag de vínculo em massa desativa o botão de confirmação do modal
    if (massAssignment) {
      document.querySelector('.bootbox-accept').disabled = true
    }
  });

  // Cria o HTML do checkbox que vai habilitar e desabilitar
  // o botão de confirmar do bootbox
  function createConfirmationCheckbox() {
    return '<br/><br/><div class="checkbox">' +
      '<label class="form-checkbox form-normal form-text" for="confirmMassAssignment"/>' +
      '<input id="confirmMassAssignment" class="form-control" name="confirmMassAssignment" type="checkbox"/>' +
      '<span>' + Lang.get('js/src/events/confirm.yes_continue') + '</span></div>';
  }
}
